import useFetchCustomForm from './useFetchCustomForm';
import useSaveQuestionAnswer from './useSaveQuestionAnswer';
import useNavigatePreviousQuestion from './useNavigatePreviousQuestion';
import useRestartCustomForm from './useRestartCustomForm';
import startCustomForm from './useStartCustomForm';

export * from './types';

export const useCustomFormById = useFetchCustomForm;
export const useCustomFormSaveQuestionAnswer = useSaveQuestionAnswer;
export const useCustomFormNavigatePreviousQuestion =
  useNavigatePreviousQuestion;
export const useCustomFormRestart = useRestartCustomForm;
export const useCustomFormStart = startCustomForm;
